export default __webpack_public_path__ + "animate-pill-8ea12fdaf235e583f5edea7ef59b8a65.svg";